module.exports = __webpack_public_path__ + "img/scalable.9b641cb9.png";